module.exports = __webpack_public_path__ + "img/designer.2348d120.png";